<form
  #form="ngForm"
  novalidate
>
  <h1 class="mb-4 justify-self-center text-xl">Total consumptions</h1>

  <div
    class="mt-2 flex flex-row gap-1"
    data-ping-host
  >
    <div class="flex flex-col content-center items-end gap-1">
      <span class="h-6"></span>
      @for (row of rows; track row.key) {
        <nsp-input-label
          [label]="row.label"
          class="h-10.5"
          [required]="row?.required ?? false"
          [id]="row.key"
        />
      }
    </div>
    <div class="flex min-w-0 flex-1 flex-row overflow-hidden">
      @let fuelspecs = consumptionsStore.fuelSpecs().entries;

      @let entries = consumptionsStore.totalConsumptions().entries;
      @for (
        entry of object.values(entries);
        let entryIndex = $index;
        track entryIndex
      ) {
        <div class="flex min-w-0 flex-1 basis-0 flex-col gap-1">
          @let selectedIsoGrade = fuelspecs[entryIndex]?.isoFuelGrade?.value;
          @let selectedFuelType = fuelspecs[entryIndex]?.fuelType?.value;
          <span
            class="h-6 overflow-hidden text-center text-ellipsis whitespace-nowrap"
          >
            {{ selectedFuelType?.name }}
            @if (selectedIsoGrade) {
              {{ '- ' + selectedIsoGrade?.name }}
            }
          </span>
          @for (row of rows; track row.key) {
            @let id = `entries-${row.key}-${entryIndex}`;
            @let input = entry?.[row.key];
            @let disabled =
              !fuelspecs[entryIndex]?.fuelType?.value ||
              !fuelspecs[entryIndex]?.isoFuelGrade?.value;
            @if (row.key !== 'total') {
              <nsp-number-input
                class="w-full min-w-0"
                [id]="id"
                [name]="id"
                tooltipPosition="top"
                tooltipStyleClass="text-white"
                [required]="isRowRequired(row.key, row?.required)"
                [invalidOverride]="
                  !disabled && isRowRequired(row.key, row?.required)
                "
                [ngModel]="input?.value"
                [disabled]="disabled"
              />
            } @else {
              <nsp-number-input
                class="w-full min-w-0"
                [id]="id"
                [name]="id"
                [value]="consumptionsStore.vm().calculateTotal(entryIndex)"
                [ngModel]="consumptionsStore.vm().calculateTotal(entryIndex)"
                [readonly]="true"
              />
            }
          }
        </div>
      }
    </div>
  </div>
</form>
